module.exports = __webpack_public_path__ + "static/media/deeplearning_ai_logo.1a0961c4.png";